/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from 'react';
import { DataTable as DataTable_ } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ChevronDownIcon } from 'primereact/icons/chevrondown';
import { ChevronUpIcon } from 'primereact/icons/chevronup';
import { SortAltIcon } from 'primereact/icons/sortalt';
import { Paginator, PaginatorPageChangeEvent } from 'primereact/paginator';
import { DataTableProps, dropdownOptions } from './DataTable.type';
import { paginationTemplate } from './PaginationTemplate';
import { useDataTableStore } from '@/store/DataTableStore/DataTableStore';
import { PaginationButton } from './PaginationButton';

const DataTable = <Data extends Record<string, unknown>>({
  columns,
  value,
  withPaginator,
  loading,
  listlimit = dropdownOptions[0].value,
  limitHandler,
  countTotal,
  currentPageHandler,
  currentPage,
}: DataTableProps<Data>) => {
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(listlimit);
  const { currentPageValue } = useDataTableStore();

  const handlePageChange = (e: PaginatorPageChangeEvent) => {
    setFirst(e.first);
    setRows(e.rows);
    limitHandler && limitHandler(e.rows);
  };

  const paginatedValue = value.slice(first, first + rows);

  const renderSortIcon = (options: any) => {
    const icon = options.sorted ? (
      options.sortOrder < 0 ? (
        <ChevronDownIcon
          {...options.iconProps}
          className="text-[#fff] ml-[0.3125rem] h-2.5"
        />
      ) : (
        <ChevronUpIcon
          {...options.iconProps}
          className="text-[#fff] ml-[0.3125rem] h-2.5"
        />
      )
    ) : (
      <SortAltIcon
        {...options.iconProps}
        className="text-[#fff] ml-[0.3125rem] h-2.5"
      />
    );
    return icon;
  };

  return (
    <div className="min-w-[50rem] bg-[#131311] p-4">
      <DataTable_
        value={paginatedValue}
        sortIcon={renderSortIcon}
        loading={loading}
      >
        {columns.map((col) => (
          <Column
            key={col.field}
            field={col.field}
            header={col.header}
            sortable={col.sortable !== false}
            headerClassName={`text-primary bg-bgColor text-sm font-bold ${col.headerClassName || ''}`}
            bodyClassName={`text-white bg-bgColor border-b border-rowDividerBg ${col.bodyClassName || ''}`}
          />
        ))}
      </DataTable_>

      {withPaginator && (
        <div className="flex justify-end p-2 items-center mt-2">
          <Paginator
            template={paginationTemplate(currentPage ?? 1)}
            first={first}
            rows={rows}
            totalRecords={countTotal}
            onPageChange={handlePageChange}
            className="justify-content-end bg-transparent"
          />
          <div className="flex relative top-1 gap-2">
            <PaginationButton
              onClick={() => {
                if (currentPage && currentPage > 0)
                  currentPageHandler && currentPageHandler(currentPage - 1);
              }}
              icon="pi-chevron-left"
              disabled={currentPage === 1}
            />
            <PaginationButton
              onClick={() => {
                if (currentPage) {
                  currentPageHandler && currentPageHandler(currentPage + 1);
                }
              }}
              icon="pi-chevron-right"
              disabled={currentPage === currentPageValue}
            />
          </div>
          ;
        </div>
      )}
    </div>
  );
};

export default DataTable;
